import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import validate from 'validate.js';

// Date Time
validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse: (value, options) => {
    return +moment.utc(value);
  },
  // Input is a unix timestamp
  format: (value, options) => {
    const format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
    return moment.utc(value).format(format);
  },
});

// Arrays
validate.validators.array = (value, options, key, attributes) => {
  if (isEmpty(value)) {
    return null;
  }
  if (!Array.isArray(value)) {
    return key + ' must be an array.';
  }
  if (options.hasOwnProperty('min') && !value.length) {
    return key + ' must hav at least one item.';
  }
  if (!options.hasOwnProperty('items')) {
    return null;
  }

  const errors = {};
  forEach(value, function (item, itemKey) {
    let itemErrors = validate(item, options.items);
    if (isEmpty(itemErrors)) {
      return true;
    }

    forEach(itemErrors, function (err, errorKey) {
      errors[key + '.' + itemKey + '.' + errorKey] = err;
    });
  });
  if (isEmpty(errors)) {
    return null;
  }
  return errors;
};

//Required without
validate.validators.requiredWithout = (value, options, key, attributes) => {
  if (typeof options === 'string') {
    options = [options];
  }
  if (!Array.isArray(options)) {
    return null;
  }
  let hasOther = false;
  forEach(options, (withoutAtt) => {
    if (attributes.hasOwnProperty(withoutAtt) &&
      !isEmpty(attributes[withoutAtt])) {
      hasOther = true;
      return false;
    }
  });
  if (hasOther) {
    return null;
  }
  if (options.length > 1) {
    return key + ' is required when ' + options.join(' / ') + ' are missing';
  }
  return key + ' is required when ' + options[0] + ' is missing';
};

//Required without
validate.validators.confirmed = (value, options, key, attributes) => {
  if (typeof value !== 'string' || isEmpty(value)) {
    return null;
  }
  const confirmationKey = key + 'Confirmation';
  if (!attributes.hasOwnProperty(confirmationKey)) {
    return 'needs confirmation.';
  }
  if (value !== attributes[confirmationKey]) {
    return 'does not match the confirmation';
  }
  return null;
};

//RequiredIf
validate.validators.requiredIf = (value, options, key, attributes) => {
  if (typeof value !== 'function') {
    if (!value()) {
      return key + ' can\'t be blank.';
    }
  }
  return null;
};

validate.validators.arrayOfObjects = (arrayItems, itemConstraints) => {
  if (!Array.isArray(arrayItems)) {
    return null;
  }
  const arrayItemErrors = arrayItems.reduce(
    (errors, item, index) => {
      const error = validate(item, itemConstraints, {fullMessages: false});
      if (error) errors[index] = error;
      return errors;
    },
    {},
  );

  return isEmpty(arrayItemErrors) ? null : arrayItemErrors;
};


validate.validators.emptyUrl = function (value, options) {
  if (!value) {
    return null;
  }
  const errors = validate.validate(
    {
      value: value,
    },
    {
      value: {
        url: options,
      },
    },
    {fullMessages: options.fullMessages}
  );
  return errors ? errors.value : null;
};

validate.validators.includesLetter = function (value, options) {
  if (typeof options !== 'boolean') {
    throw new Error('includesLetter option must be a boolean!');
  }

  if (!options || /[a-zA-Z]/.test(value)) {
    return null;
  }
  return 'must contain at least 1 letter!';
};

export default validate;
